import styled from "styled-components";

export const TableWrapper = styled.div`
  .ant-table {
    box-shadow: 6px 6px 35px rgba(0, 0, 0, 0.15);
    margin-bottom: 3rem;

    .ant-table-thead th {
      background: #fff;
      color: #334d6e;
      opacity: 0.5;
    }

    tr td:first-child,
    tr th:first-child {
      padding-left: 5rem;
    }
  }

  .ant-pagination li {
    background-color: #f0f0f0;

    &,
    button {
      border-radius: 1rem;
    }
  }
`;
